import { Navigate, Outlet } from 'react-router-dom';

import {
  LOGIN_HOME,
  REQUESTS_ROUTE,
  REQUESTS_ROUTE_PDP_DETAIL,
} from '../constants/routePathConstants';
import { useUserContext } from '../contexts/UserContext';
import RequestsV2 from '../screens/Requests/RequestsV2';
import { isCuratorPage } from '../helpers/urlHelper';
import { isConfiguratorView, isPublicPageView, isRetailAutomation } from '../components/Configurator/utils';

const AdminGuard = () => {
  let referrer = window.location.pathname + window.location.search;
  referrer = referrer ? `?referrer=${referrer}` : '';

  const userCtx = useUserContext();
  if (userCtx.token && userCtx.refreshToken && userCtx.currentUser) {
    return (
      <>
        <Outlet />

        {/* Load the RequestsV2 component with an iframe. It should be loaded once and toggled based on the current route. Avoid loading it in 3D contexts.
           Fix: correctly detect req-detail routes instead of comparing literal pattern string. */}
        <RequestsV2
          show={window.location.pathname?.includes(REQUESTS_ROUTE)}
          preload={
            !isCuratorPage() &&
            !isConfiguratorView() &&
            !isRetailAutomation() &&
            !isPublicPageView() &&
            // Do not preload on req-detail pages (actual paths like /req-detail/123)
            !window.location.pathname.startsWith(REQUESTS_ROUTE_PDP_DETAIL.replace(':id', ''))
          }
        />
      </>
    );
  } else {
    return <Navigate to={LOGIN_HOME + `${referrer}`} />;
  }
};

export default AdminGuard;
